import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { z } from "zod";

export const createLoacalisedAddToFavSchema = (locale: Locales) => {
  const listNameSchema = z
    .string({ required_error: __("List name is required", locale) })
    .trim()
    .min(1, __("Invalid List Name", locale))
    .max(30, __("Maximum 30 characters", locale));

  const dateSchema = z.object({
    from: z.date({ required_error: __("Date is required", locale) }),
    to: z.date({ required_error: __("Date is required", locale) }),
  });

  const addToFavSchema = z.object({
    listName: listNameSchema,
    date: dateSchema,
  });

  return { addToFavSchema };
};

type SchemaSet = ReturnType<typeof createLoacalisedAddToFavSchema>;

export type AddToFavSchema = z.infer<SchemaSet["addToFavSchema"]>;
